import { useContext } from "react";
import { db } from "../../../firebase/config";
import { useFirestore } from "../../../firebase/useFirestore";
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import ReadOnlyGuard from "../../common/ReadOnlyGuard";

const ThankYouText = () => {
    const [saved, setSaved] = useContext(SavedIcon);

    const compagny = useFirestore("CompagnyMeta");

    const updateField = (fieldName) => (e) => {
        const value = e.target.value;
        const docid = e.target.dataset.docid;

        db.collection("CompagnyMeta")
            .doc(docid)
            .update({
                [fieldName]: value,
            })
            .then(() => {
                setSaved("flex");
            });
    };

    return (
        <div className="dashboard-container">
            <h2>Bedanktekst</h2>
            <p>
                Deze tekst verschijnt onderaan intake-formulieren nadat iemand het formulier heeft verzonden.
            </p>
            {compagny && compagny.map((comp) => (
                <ReadOnlyGuard key={comp.ID} edit="addresses.edit">
                <div className="privacy-policy-fields">
                    <div className="privacy-policy-row">
                        <div className="privacy-policy-field">
                            <label>Bedanktekst</label>
                            <textarea
                                className="input-classic"
                                data-docid={comp.docid}
                                defaultValue={comp.ThankYouText || ""}
                                onChange={updateField("ThankYouText")}
                                placeholder="Bedankt voor het invullen van het formulier. We nemen zo snel mogelijk contact met je op. Je kunt het formulier nu sluiten."
                                rows={3}
                            />
                        </div>
                    </div>
                </div>
                </ReadOnlyGuard>
            ))}
        </div>
    );
};

export default ThankYouText;
